import * as React from "react";
import EYLogoAndHelpUrl from "../EYLogoAndHelpUrl";
import { labels } from "../../util/utils";
import styled from "styled-components";
import { MotifIcon } from "@ey-xd/motif-react";
import { IconoirProhibition } from "@ey-xd/motif-icon";

function BoundSheetAlreadyExistErrorLayout() {
  return (
    <StyledMainSection>
      <section className="body-wrap">
        <section className="body-top-wrap">
          <EYLogoAndHelpUrl />
          <section className="boundsheet-section">
            <span className="boundsheet-logo">
              <MotifIcon src={IconoirProhibition} size="28" />
            </span>
            <p className="boundsheet-msg-1 motif-body1-default-regular">{labels.boundSheetAlreadyExist_1}</p>
            <p className="boundsheet-msg-2 motif-body2-default-light">{labels.boundSheetAlreadyExist_2}</p>
          </section>
        </section>
      </section>
    </StyledMainSection>
  );
}

export default BoundSheetAlreadyExistErrorLayout;

const StyledMainSection = styled.section`
  .body-wrap {
    position: relative;
    flex-flow: column;
    display: flex;
    background-color: var(--neutrals-00white);
    // padding: var(--px-12) var(--px-24);
    height: 100vh;
    .body-top-wrap {
      padding: var(--spacing-medium) var(--spacing-x-large) var(--spacing-x-large) var(--spacing-x-large);

      .boundsheet-section {
        display: flex;
        flex-direction: column;
        align-items: center;
        .boundsheet-logo {
          padding: var(--px-14);
          border-radius: var(--px-44);
          background-color: var(--neutrals-50);
          width: 21%;
          margin-bottom: var(--px-16);
          .motif-icon {
            display: flex;
            align-items: center;
            color: var(--neutrals-700);
          }
        }
        .boundsheet-msg-1 {
          width: var(--px-250);
          margin: 0 auto;
          text-align: center;
          color: var(--neutrals-900);
        }
        .boundsheet-msg-2 {
          color: var(--neutrals-700);
          margin: var(--px-4) auto;
        }
      }
    }
  }
`;
